/* eslint-disable no-shadow */
/* eslint-disable no-console */
import React, { Component, createRef } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import {
    Grid,
    Row,
    Column,
    Keyboard,
    Button,
    Heading,
    Form,
    FormInput,
    cls,
    ColoredButton,
    TranslationID
} from 'packages/components';

import Device from '../../devices/device';
import { autobind } from '../../packages/core/lib';
import Assets from '../../requests/apa/Asset';
import { MODAL_TERM_AND_COND, MODAL_PROMOTION_TELMEX_TELCEL, AAF_MODAL_ERROR, showModal , HIDE_MODAL } from '../../actions/modal';
import Translator from '../../requests/apa/Translator';
import { REGISTER, REGISTER_INPUT_STYLE_OUTFOCUS } from '../utils/constants';
import { LOGIN_EMAIL, LOGIN_NET,  LOGIN_HDTV} from '../../AAF/Auth/authConstants';

import AAF from './../../AAF/AAF';
import { regExp} from 'packages/components/lib/Input/utils';
import { getUserInfo } from '../../requests/loader';
import DeviceStorage  from '../../components/DeviceStorage/DeviceStorage';

import { createAsyncEvent } from '../../utils/analytics';
import * as constants from '../../AAF/Auth/authConstants';
import { receiveIsLoggedIn, fetchPushSession , setValidEmail} from '../../reducers/user';
import {setMetricsEvent} from "../../actions/metrics";
import Spinner from './../../components/Spinner';
import RegisterLogic from './RegisterLogic';
import './_styles.scss';
import store from '../../store';
import Utils from '../../utils/Utils';
import UtilsIsLoggedIn from '../../utils/user/isLoggedIn';
import { REGISTRO,
    ACEPTAR_TERMINOS_Y_CONDICIONES,
    CONOCE_LAS_PROMOCIONES,
    CONOCE_LAS_PROMOCIONES_ENTENDIDO,
    INICIA_SESION,
    CORREO_SIGUIENTE,
    CORREO_CANCELAR,
    CORREO_INGRESAR_CONTRASEÑA_SIGUIENTE,
    CORREO_INGRESAR_CONTRASEÑA_CANCELAR,
    COMPONENTE_REGISTRO
} from '../utils/constansMetrics';
import {GA4} from 'src/utils/trackers/GA4';
import {METHOD_EMAIL} from 'src/utils/trackers/GA4Constants';
import { getUrlRedirectBack } from 'src/components/Modal/functions/ModalKeepWatching/functions';
import { fetchLinealChannels } from '../../actions/payway';
import {
    trackAuthRegisterFailed,
    trackAuthRegisterSubmitted,
    trackAuthRegisterSuccess,
} from '../../services/datadog/auth';

interface IRegisterProps {
    element: JSX.Element[] | JSX.Element;
    showModal: (props: object) => void;
}

interface IRegisterState {
    first: boolean;
    second: boolean;
    isTelmex: boolean;
    valueEmail: string;
    valuePassword: string;
    showPassword: boolean;
    checked: boolean;
    valid: boolean;
    errorFromBackend: string;
    isValidEmail: boolean;
    isSubmit: boolean;
    isLoading: boolean;
    isRegisterNet: boolean;
    analyticsEvent?: any;
    error: boolean;
    device: string;
    focusWhenMount: boolean;
}

class Register extends Component<RouteComponentProps & IRegisterProps, IRegisterState> {
    private isValidForm: boolean;
    private translations: Record<TranslationID, string>;
    private firstname: string;
    private lastname: string;
    private isValidInput: boolean;
    public headerLogo: string = Assets.get('logo_clarotv') || '';
    public passwordShowButtonOff: string = Assets.get('password_access_show_button_off') || '';
    public passwordShowButtonOn: string = Assets.get('password_access_show_button_on') || '';
    public modalErrorCode = false;
    private registerLogic: RegisterLogic;
    private IsTypeTootlipOther: boolean;
    private isValidFormPassword: boolean;

    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    public btnNumberMobile: string = Translator.get(
        'register_access_option_button_promotions',
        ''
    );

    public analyticsEvent = createAsyncEvent({
        send: event => {
            this.props.setMetricsEvent(event);
            this.props.setMetricsEvent({ type: 'executor' });
        },
        action: constants.REGISTRY_EVENT_ACTION,
        category: constants.REGISTRY_EVENT_CATEGORY,
        successLabel: constants.REGISTRY_EVENT_SUCCESS_LABEL,
        errorLabelPrefix: constants.REGISTRY_EVENT_ERROR_LABEL_PREFIX
    });

    constructor(props: RouteComponentProps & IRegisterProps) {
        super(props);
        const {history : {location: {state: {ipTelmexData: {isTelmex = false, firstname = '', lastname =''} = {}} = {}} = {}} = {}} = props;
        this.firstname = firstname;
        this.lastname = lastname;

        this.state = {
            first: true,
            second: false,
            isTelmex,
            valueEmail: '',
            valuePassword: '',
            showPassword: false,
            checked: false,
            valid: false,
            errorFromBackend: '',
            isValidEmail: false,
            isSubmit: false,
            isLoading: false,
            isRegisterNet : !!(this.props.location.typeRegisterNet || this.props.location.typeRegisterNet == LOGIN_EMAIL),
            error: false,
            device: Device.getDevice().getPlatform(),
            focusWhenMount: true
        };

        this.isValidForm = false;
        this.isValidFormPassword = false;
        this.isValidInput = false;
        this.registerLogic = new RegisterLogic(this.props);
        this.IsTypeTootlipOther = DeviceStorage.getItem('region') == 'brasil' ? true : false ;

        this.translations = {
        'password_title': Translator.get('password_tooltip_title_label','Tu contraseña debe incluir'),
        'password_tooltip_letter': Translator.get('password_tooltip_letter_label_validation','Mayúsculas y minúsculas'),
        'password_tooltip_number': Translator.get('password_tooltip_number_label_validation','Al menos un número'),
        'password_tooltip_length': Translator.get('password_tooltip_length_label_validation','8 o más caracteres'),
        'password_tooltip_especial_character': Translator.get('password_tooltip_especial_character_label_validation','Sin caracteres especiales'),
        'password_tooltip_completeField': Translator.get('password_tooltip_completeField_label_validation','Debes completar este campo'),
        'password_tooltip_check': Translator.get('password_tooltip_checkTermsConditions_label_validation','Debes aceptar los términos y condiciones'),
        'email_tooltip_valid': Translator.get('email_tooltip_valid_label_validation','Ingresa un correo electrónico válido.'),
        'registerMail_tooltip_error': Translator.get('registerMail_tooltip_error_label','Este correo ya está vinculado a la base de datos de Claro video.'),
        'error_server_tooltip': Translator.get('USR_USR_00009','Hubo un error. Por favor, intenta más tarde.'),
    };
      this.keys = Device.getDevice().getKeys();
      }

    public componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.removeEventListener('keydown', this.handleKeyPress, true);
        document && document.removeEventListener('keydown', this.onBlur, true);
        document && document.removeEventListener('keydown', this.onFocus, true);
    }

    public componentDidMount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.handleKeyPress, true);
        document && document.addEventListener('keydown', this.onBlur, true);
        document && document.addEventListener('keydown', this.onFocus, true);
        Utils.setInitialFocus('.aaf_form-group-input-element .aaf_focusable');
    }

    private handleNext = (): void => {
        Utils.sendMetric(this.props, REGISTRO,  CORREO_SIGUIENTE, COMPONENTE_REGISTRO);
        const {first, valueEmail, valuePassword, checked, isTelmex} = this.state;
        let inputToValue = valueEmail !== '' ? valueEmail : valuePassword;
        if (first) {
          if (inputToValue === '') {
            this.setState({ valid: false, isSubmit: true, errorFromBackend: this.translations['password_tooltip_completeField']});
          } else
          if (!this.validInputText(inputToValue)) {
            this.setState({ valid: false, isSubmit: true, errorFromBackend: this.translations['email_tooltip_valid']});
          } else {
            this.setState({ valid: true, isSubmit: true, isValidEmail: true,  errorFromBackend: this.translations['email_tooltip_valid']});
          }
          if (this.validInputText(inputToValue) && (checked || isTelmex)) {
            getUserInfo(valueEmail).then((response) => {
                const {status} = response;
                if (status === "0"){ // Ya existe
                    this.isValidForm = false;
                    this.setState({ first: true, second: false, valid:false, errorFromBackend: this.translations['registerMail_tooltip_error']});
                } else {
                    this.isValidFormPassword = this.getValidPassword(valuePassword);
                    this.isValidForm = this.isValidFormPassword
                    this.setState({ first: false, second: true, valid: this.isValidForm, errorFromBackend: ''});
                }
            })
            .catch(() => {
                this.isValidForm = false
                this.setState({ first: true, second: false, valid: false, errorFromBackend: this.translations['error_server_tooltip']});
            });
        }
        }
    };

    private handleCancel = (): void => {
        const { history } = this.props;
        const { isTelmex } = this.state;
        Utils.sendMetric(this.props, REGISTRO,  this.state.first ? CORREO_CANCELAR : CORREO_INGRESAR_CONTRASEÑA_CANCELAR , COMPONENTE_REGISTRO);
        if(isTelmex) {
            const urlRedirect = getUrlRedirectBack('/node/homeuser');
            history.push(urlRedirect);
        } else{
            const urlRedirect = getUrlRedirectBack('/landing');
            history.push(urlRedirect);
        }
    };

    private handleActions = (action: string): void => {
        const { history } = this.props;
        if (action === 'login') {
            history.push('/login');
        } else {
            this.registerLogic.setLegals(this.props);
        }
    };

    handlePromotions = (): void => {
        const { showModal, history } = this.props;
        const fromdetail = history && history.location && history.location.state && history.location.state.from
                        || history && history.location && history.location.state && history.location.state.fromdetail;
        Utils.sendMetric(this.props, REGISTRO,  CONOCE_LAS_PROMOCIONES, COMPONENTE_REGISTRO);
        showModal({
            modalType: MODAL_PROMOTION_TELMEX_TELCEL,
            modalProps: {
                callback: () => {
                    Utils.sendMetric(this.props, REGISTRO,  CONOCE_LAS_PROMOCIONES_ENTENDIDO, COMPONENTE_REGISTRO);
                    history.replace('/register', { from: fromdetail });
                },
            content: '',
            align: 'right'
            },
        });
    };

    private validInputText = (valueInput: string): boolean => {
        return regExp.validEmail.test(valueInput) || regExp.hasNumberMobile.test(valueInput);
    };

    private getValidPassword= (value: string): boolean => {
        return regExp.isValidPassword.test(value) && regExp.validtext.test(value);
    };

    private handleChangeCheck = (checked: boolean = false) : void =>{
        this.isValidInput = this.validInputText(this.state.valueEmail || this.state.valuePassword);
        this.isValidForm = (this.state.valueEmail !== '' || this.state.valuePassword !== '') && checked;
        this.setState({checked, valid: this.isValidInput, errorFromBackend: '', isSubmit: false});
        Utils.sendMetric(this.props, REGISTRO,  ACEPTAR_TERMINOS_Y_CONDICIONES, COMPONENTE_REGISTRO);
    };

    private handleChange = (event: string): void => {

        const { first, isTelmex, checked} = this.state;
        let { errorFromBackend } = this.state;

        let valueInput = event;

        this.isValidInput = this.validInputText(event);

        if(!isTelmex) {
            this.isValidForm = valueInput !== '' && checked;
        } else {
            this.isValidForm = valueInput !== '';
        }
        if (first) {
            if (valueInput === '') {
                errorFromBackend = '';
            }
            this.setState({ valueEmail: valueInput, isValidEmail:this.isValidInput, valid: this.isValidInput, errorFromBackend});
        }
       this.setState({ valueEmail: valueInput, valid: this.isValidInput, errorFromBackend: ''});
    };

    private handleChangePassword = (event: string): void => {
        this.isValidFormPassword = this.getValidPassword(event);
        this.setState({ valuePassword : event, errorFromBackend: '' });
        if(this.isValidFormPassword) {
            setTimeout( () => {
            this.setState({ valid: this.isValidFormPassword })
            }, 2000);
        } else {
            this.setState({ valid: this.isValidFormPassword })
        }
    };

    private handleShowPassword = (): void => {
        const { showPassword } = this.state;
        this.setState({ showPassword: !showPassword });
    };

    private handleSubmit = (): void => {
        Utils.sendMetric(this.props, REGISTRO,  CORREO_INGRESAR_CONTRASEÑA_SIGUIENTE, COMPONENTE_REGISTRO);
        const { valueEmail, valuePassword , isTelmex} = this.state;
        const data = {
            email: valueEmail,
            password: valuePassword,
            accepterms: 1,
        };

        if (valuePassword === '') {
            this.setState({valid: false, errorFromBackend: this.translations['password_tooltip_completeField']});
            return;
        } else if (
            !regExp.hasLowerLetter.test(valuePassword) ||
            !regExp.hasUpperLetter.test(valuePassword) ||
            !regExp.hasNumbers.test(valuePassword) ||
            !regExp.hasAtLeast8Chr.test(valuePassword) ||
            !regExp.validtext.test(valuePassword)) {
            this.setState({ error: true });
        } else {
            if(!this.isValidFormPassword) return;
            trackAuthRegisterSubmitted({
                origin: 'register',
            });
            if (isTelmex) {
                const dataIpTelmex = {
                    firstname: this.firstname,
                    lastname: this.lastname,
                    email: valueEmail,
                    password: valuePassword,
                };
                this.registerIpTelmex(dataIpTelmex);
            }else {
                this.register(data);
            }
        }
    };

    private sendGA4Metric(user_id: string, parent_id: string){
        const gA4 = new GA4();
        gA4.sendRegisterEvent(METHOD_EMAIL, user_id, parent_id);
    }

    private register = (data : object): void => {
        this.setState({ isLoading: true });
        AAF.Auth.register
            .byEmail(data)
            .then((response) => {
                if (response.success) {
                    trackAuthRegisterSuccess({
                        origin: 'register',
                    });
                    this.registerLogic.successRegister(response.data);
                    UtilsIsLoggedIn.setIntervalSuspendedAccount();
                    if (response.data) {
                        const {user_id, parent_id} = response.data;
                        this.sendGA4Metric(user_id, parent_id);
                    }
                } else {
                    this.modalErrorCode = response.error || response.error.code;

                    if (response.error) {
                        trackAuthRegisterFailed(response.error, {
                            origin: 'register',
                        });
                        this.analyticsEvent.error(response.error.completeError.errors);
                    }
                }
            })
            .catch((err) => {
                const { showModal } = this.props;
                this.setState({ isLoading: false });
                trackAuthRegisterFailed(err, {
                    origin: 'register',
                });
                showModal({
                    modalType: AAF_MODAL_ERROR,
                    modalProps: {
                        callback: (): void => this.setState({ valid: false, first: true, isRegisterNet: false, second: false, valueEmail: '', valuePassword: '', errorFromBackend: '' }),
                        content: err.response
                    }
                });
            });
    };

    private gotoLogin = (): void => {
        const { history } = this.props;
        Utils.sendMetric(this.props, REGISTRO,  INICIA_SESION, COMPONENTE_REGISTRO);
        history.push('/login' , { from: 'register'});
    };

    private registerIpTelmex = (data : object) => {
        this.setState({ isLoading: true });
        AAF.Auth.iptelmex.
            uptateUserPassword(data).then((response) => {
                const {response :{status = '', code = ''} = {} } = response || {};
                if (status === '0' || code === 'update_successful') {
                    trackAuthRegisterSuccess({
                        origin: 'register_iptelmex',
                    });
                    const { history } = this.props;
                    store.dispatch(setValidEmail(true));
                    history.push('/')
                } else {
                    if (response.error) {
                        trackAuthRegisterFailed(response.error, {
                            origin: 'register_iptelmex',
                        });
                        this.analyticsEvent.error(response.error.completeError.errors);
                    }
                }
            })
            .catch((err) => {
                const { showModal } = this.props;
                this.setState({ isLoading: false });
                trackAuthRegisterFailed(err, {
                    origin: 'register_iptelmex',
                });
                showModal({
                    modalType: AAF_MODAL_ERROR,
                    modalProps: {
                        content: err.response
                    }
                });
            });
    };

    private getComponentBrasil = (type: string, first: boolean, second:  boolean): JSX.Element => {
        let text: string = '';
        let registerNetType = this.props.location.typeRegisterNet;
        let { element } = this.props;

        switch(type) {
            case 'title': {
                if (first){
                    switch (registerNetType) {
                      case LOGIN_EMAIL:
                      default:
                        text = Translator.get('register_access_title_label','Cadastre-se');
                        break;
                      case LOGIN_NET:
                        text = Translator.get('register_accessNET_title_label','Cadastre-se na NET');
                        break;
                      case LOGIN_HDTV:
                        text = Translator.get('register_accessHDTV_title_label','Cadastre-se');
                        break;
                    }
                }
                else if (second){
                    text = Translator.get('register_access_title_label','Completa tus datos');
                }
                element = (
                    <Heading size={1} className={cls(`${REGISTER}-title`)}>
                        {text}
                    </Heading>
                );
                break;
            }
            case 'subtitle': {
                if (first){
                  switch (registerNetType) {
                    case LOGIN_EMAIL:
                    default:
                      text = Translator.get('register_access_description_label','Qual é seu número Claro?');
                      break;
                    case LOGIN_NET:
                      text = Translator.get('register_accessNET_description_label','Qual é seu CPF ou usuário NET?');
                      break;
                    case LOGIN_HDTV:
                      text = Translator.get('register_accessHDTV_description_label','Qual é seu e-mail ou CPF?');
                      break;
                  }
                }
                else if(second && registerNetType === LOGIN_EMAIL)  {
                    text = Translator.get('register_validationCode_description','Código de validacao enviado para o seu celular via SMS');
                } else {
                    text = Translator.get('userProfile_password_description_label','Ingresa tu contraseña');
                }
                element = (
                    <Heading size={2} className={cls(`${REGISTER}-subtitle`)}>
                        {text}
                    </Heading>
                );
                break;
            }
            case 'email_placeholder':
                element = Translator.get('register_access_placeHolder_textfield','Ingresa tu correo electrónico');
                break;
            case 'password_placeholder':
                element = Translator.get('userProfile_password_placeHolder_textfield','Ingresa tu contraseña');
                break;
            case 'button_next':
                if (first){
                    element = Translator.get('userProfile_complete_option_button_next','SIGUIENTE');
                }else if(second){
                    element = Translator.get('userProfile_password_option_button_next','SIGUIENTE');
                }
                break;
            case 'button_cancel':
                if (first){
                    element = Translator.get('userProfile_complete_option_button_cancel','CANCELAR');
                }else if(second){
                    element = Translator.get('userProfile_password_option_button_cancel','CANCELAR');
                }
                break;
            case 'button_login':
                element = Translator.get('userProfile_complete_option_button_login','¿Ya tienes cuenta? Inicia sesión');
                break;
            default: {
                break;
            }
        }
        return element as JSX.Element;
    };

    private getComponent = (type: string): JSX.Element => {
        const { first, second, isTelmex } = this.state;
        let { element } = this.props;
        let text = '';
        const isBrasil = DeviceStorage.getItem('region') == 'brasil';

        if( isBrasil){
            return this.getComponentBrasil(type, first, second);
        }

        switch (type) {
            case 'title':
                if (!isTelmex) {
                    text = Translator.get('register_access_title_label','Regístrate');
                } else {
                    if (first){
                        text = Translator.get('userProfile_complete_title_label','Completa tus datos');
                    }
                    else if (second){
                        text = Translator.get('userProfile_password_title_label','Completa tus datos');
                    }
                }
                element = (
                    <Heading size={1} className={cls(`${REGISTER}-title`)}>
                        {text}
                    </Heading>
                );
                break;
            case 'subtitle':
                if (first && isTelmex) {
                    text = Translator.get('userProfile_complete_description_label','¿Cuál es tu correo electrónico?');
                } else if (first && !isTelmex) {
                    text = Translator.get('register_access_description_label','¿Cuál es tu correo electrónico?');
                } else if (second && !isTelmex) {
                    text = Translator.get('register_password_description_label', 'Elige una contraseña');
                } else if (second && isTelmex) {
                    text = Translator.get('userProfile_password_description_label','Ingresa tu contraseña');
                }
                element = (
                    <Heading size={2} className={cls(`${REGISTER}-subtitle`)}>
                        {text}
                    </Heading>
                );
                break;
            case 'email_placeholder':
                element = isTelmex?
                    Translator.get('userProfile_complete_placeHolder_textfield','Ingresa tu correo electrónico'):
                    Translator.get('register_access_placeHolder_textfield','Correo');
                break;
            case 'password_placeholder':
                element = isTelmex?
                    Translator.get('userProfile_password_placeHolder_textfield','Ingresa tu contraseña'):
                    Translator.get('register_password_placeHolder_textfield', 'Ingresa tu contraseña');
                break;
            case 'button_next':
                if (isTelmex){
                    if (first){
                        element = Translator.get('userProfile_complete_option_button_next','SIGUIENTE');
                    }else if(second){
                        element = Translator.get('userProfile_password_option_button_next','SIGUIENTE');
                    }
                }
                else{
                    element = Translator.get('register_password_option_button_next', 'SIGUIENTE')
                }
                break;
            case 'button_cancel':
                if (isTelmex){
                    if (first){
                        element = Translator.get('userProfile_complete_option_button_cancel','CANCELAR');
                    }else if(second){
                        element = Translator.get('userProfile_password_option_button_cancel','CANCELAR');
                    }
                }
                else{
                    element = Translator.get('register_password_option_button_cancel', 'CANCELAR')
                }
                break;
            case 'button_login':
                element = Translator.get('userProfile_complete_option_button_login','¿Ya tienes cuenta? Inicia sesión');
                break;
            default:
        }
        return element as JSX.Element;
    };

    @autobind
    private handleBack(isYellow = false): void {
        const { second } = this.state;
        const { history } = this.props;
        const platf = Device.getDevice().getPlatform();
        const goCompatible = [
            'web0s',
            'tizen',
            'ps4',
            'samsung',
            'maple'
          ];
         const isGoCompatible = goCompatible.includes(platf);
        if(second){
            this.isValidForm = true;
            Utils.setInitialFocus('.aaf_form-group-input-element .aaf_focusable');
            this.isValidFormPassword = false;
            this.setState({ first: true, second: false, valid:true, errorFromBackend: '', error: false, isSubmit: false})
        }else {
            let fromDisplay  = history && history.location && history.location.state && history.location.state.from
            const fromdetail =  history && history.location && history.location.state && history.location.state.fromdetail
            const ipTelmexData = history && history.location && history.location.state && history.location.state.ipTelmexData && history.location.state.ipTelmexData.isTelmex;
            fromDisplay = fromdetail !== undefined ? fromdetail : fromDisplay;
            if ((fromDisplay !== "landing") && isYellow) {
                if(fromDisplay === 'login' || fromDisplay === 'iptelmex' || ipTelmexData){
                    history.goBack()
                }else if (isGoCompatible) {
                    if(fromDisplay !== "modalAddOn"){ 
                        history.go(-2);
                    } else{
                        history.goBack()
                    }
                } else {
                    history.goBack()
                    isYellow && fromDisplay !== "modalAddOn" && history.goBack();
                }
            }
            //form VCard buy or rent button to register
            else if (!fromDisplay && isYellow) {
                if (isGoCompatible) {
                    if(fromDisplay !== "modalAddOn"){ 
                        history.go(-2);
                    } else{
                        history.goBack()
                    }
                } else {
                    history.goBack()
                    isYellow && fromDisplay !== "modalAddOn" && history.goBack();
                }
            }
            else if (fromdetail === 'landing') {
                history.replace('landing');
            }
            //from landing (and other cases) to register
            else {
                if(fromDisplay === 'login' || fromDisplay === 'iptelmex'){
                    history.goBack()
                }else if (isGoCompatible && fromDisplay !== "landing") {
                    //Este flujo es pra hacer un back lineal desde modalAddOn 
                    if(fromDisplay !== "modalAddOn"){ 
                        history.go(-2);
                    } else{
                        history.goBack()
                    }
                } else {
                    fromDisplay !== "modalAddOn" && !ipTelmexData && history.goBack();
                }
            }
        }
    }

    @autobind
    private onKeyPress(e: any): void {
        const {modal, history} = this.props;
       
        if(modal && (modal.modalType == null || modal.modalType === HIDE_MODAL)){
            const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
            switch (currentKey) {
                case 'YELLOW':
                    if(Utils.isModalHide()) {
                        this.handleBack(true);
                    }
                    break;
            case "BACK":
                const fromDisplay = this.props.history.location.state.from || this.props.history.location.state.fromdetail; 
                 if(fromDisplay !== "landing") {
                    this.handleBack();
                 }else{
                    history.goBack()
                 }
                break
            }
        }
    }

    @autobind
    private handleKeyPress(e: any): void {
        const {modal} = this.props;
        if(modal && (modal.modalType == null || modal.modalType === HIDE_MODAL)){
            const { first } = this.state;
            const { history } = this.props;
            const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
            const existModal = store.getState().modal.modalType;
            const fromDisplay = this.props.history.location.state.from || this.props.history.location.state.fromdetail; 
            const platf = Device.getDevice().getPlatform();
            if(fromDisplay !== "landing" && fromDisplay !== "iptelmex") {
            if (currentKey === 'BACK') {
                if(first) {
                    if (!existModal){
                        e.preventDefault();
                        e.stopPropagation();
                        if ((platf === 'tizen' || platf === 'ps4' || platf === 'web0s' || platf === 'samsung' || platf === 'maple')) {
                        } else {
                            history.goBack();
                        }
                    } else {
                        history.goBack();
                    }
                } else {
                    this.isValidForm = true;
                    this.handleBack();
                }
            }
        }
        }
    }

    @autobind
    private onBlur (): void {
        const temp: any = document;
        if(temp.activeElement.id == 'password') {
            this.setState({errorFromBackend: ''});
        }
    }

    @autobind
    private onFocus (): void  {
        Utils.onFocusElement([{ id: 'emailInput'}, { id: 'password'}]);
    }

    public render(): JSX.Element {
        const { first, second, isTelmex, showPassword, valid, errorFromBackend, checked, isValidEmail, isSubmit, isRegisterNet, isLoading, error, device, focusWhenMount, valuePassword } = this.state;
        if (isLoading) return <Spinner className={cls(`${REGISTER}-spinner`)} visible={true}/>;
        return (
            <Grid>
               <Row className={cls(`${REGISTER}-row`)}>
                    <Column lg={3} className={cls(`${REGISTER}-header-logo`)}>
                        <img src={this.headerLogo} alt="claroTv logo" />
                    </Column>
                    <Column offset={7} lg={2} className={cls(`${REGISTER}-header-buttons`)}>
                        <ColoredButton
                            onClick={() => this.handleBack(true)}
                            children = {Translator.get('top_head_option_button_back','REGRESAR')}
                            color="yellow"
                            imgSrc = {Assets.get('top_head_option_back', '')}
                            onFocus = {this.onFocus}
                        />
                    </Column>
                </Row>
                <Row>
                    <Form id="user-registration-form">
                        <Column lg={6} className={cls(`${REGISTER}-column-keyboard`)}>
                            <Keyboard id="Keyboard" onFocus = {this.onFocus}
                                isRegisterNet = {isRegisterNet}
                            />
                        </Column>
                        <Column lg={6} className={cls(`${REGISTER}-column-inputs`)} >
                            <Row className={cls(`${REGISTER}-row-inputs`)}>
                                <Column lg={12}>{this.getComponent('title')}</Column>
                                <Column lg={12}>{this.getComponent('subtitle')}</Column>
                                <Row className={cls(`${REGISTER}-column-input`)}>
                                    {first && (
                                        <Column lg={12}>
                                            <FormInput
                                                id="emailInput"
                                                focusWhenMount = {focusWhenMount}
                                                name="email"
                                                errorFromBackend={errorFromBackend}
                                                type="alphanumeric"
                                                placeholder={this.getComponent('email_placeholder')}
                                                onChange={this.handleChange}
                                                validInput={valid}
                                                translations={this.translations}
                                            />
                                        </Column>
                                    )}
                                    {second && (
                                        <Row>
                                            <Column lg={8}>
                                                <FormInput
                                                    focusWhenMount = {focusWhenMount}
                                                    id="password"
                                                    name="password"
                                                    type={
                                                        !showPassword
                                                            ? 'password'
                                                            : 'password_shown'
                                                    }
                                                    placeholder={this.getComponent('password_placeholder')}
                                                    onChange={this.handleChangePassword}
                                                    validInput={valid}
                                                    showTooltipSuccess
                                                    translations={this.translations}
                                                    errorFromBackend={errorFromBackend}
                                                    error={error}
                                                    onBlur={this.onBlur}
                                                    submit = {isSubmit}
                                                    IsTypeTootlipOther = {this.IsTypeTootlipOther}
                                                />
                                            </Column>
                                            <Column
                                                lg={4}
                                                className={cls(`${REGISTER}-column-show-password`)}
                                            >
                                                <Button
                                                    type="button"
                                                    variant="default"
                                                    className={cls(
                                                        `focusable`,
                                                        `${REGISTER}-button-show-password`
                                                    )}
                                                    onClick={this.handleShowPassword}
                                                    block
                                                    img = {!showPassword ? this.passwordShowButtonOff : this.passwordShowButtonOn }
                                                >

                                                </Button>
                                            </Column>
                                        </Row>
                                    )}
                                </Row>
                                <Column lg={12} className={cls(`${REGISTER}-email-rule`)}>
                                    {first && isValidEmail && (
                                        <p className={cls(`${REGISTER}-rule-email`)}>
                                            {Translator.get('userProfile_complete_confirmMail_label')}
                                        </p>
                                    )}
                                </Column>
                                {first && !isTelmex && (
                                    <Column lg={6} className={cls(`${REGISTER}-separator-button`)}>
                                        <FormInput
                                            name="terms"
                                            type="checkbox"
                                            label={Translator.get('register_access_termsConditions_label','Acepto los términos y condiciones')}
                                            translations={this.translations}
                                            checked = {checked}
                                            onChange={this.handleChangeCheck}
                                            submit = {isSubmit}
                                        />
                                    </Column>
                                )}
                                {first && !isTelmex && (
                                    <Column lg={6}>
                                        <Button
                                            type="button"
                                            variant="dark"
                                            className={cls(
                                                `focusable`,
                                                `${REGISTER}-register-dark-button`,
                                                `${REGISTER}-column-right`
                                            )}
                                            onClick={(): void => this.handleActions(MODAL_TERM_AND_COND)}
                                        >
                                            <span>
                                                {Translator.get('register_access_option_button_termsConditions','Ver términos y condiciones')}
                                            </span>
                                        </Button>
                                    </Column>
                                )}
                                <Column lg={11}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="primary"
                                        className={cls(`focusable`, `${REGISTER}-button-next`, this.state.first && !this.isValidForm ? 'disabled' : '', this.state.second && !this.isValidFormPassword ? 'disabled': '')}
                                        onClick={first ? this.handleNext : this.handleSubmit}
                                        onFocus = {this.onFocus}
                                    >
                                        {this.getComponent('button_next')}
                                    </Button>
                                </Column>
                                <Column lg={11} className={cls(`${REGISTER}-column-next`)}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="default"
                                        className={cls(`focusable`, `${REGISTER}-button-cancel`)}
                                        onClick={this.handleCancel}
                                        onFocus = {this.onFocus}
                                    >
                                        {this.getComponent('button_cancel')}
                                    </Button>
                                </Column>
                                <Column lg={6} className={cls(`${REGISTER}-column-top`)}>
                                    {!second && this.btnNumberMobile !== '' &&  !isTelmex &&(
                                        <Button
                                            type="button"
                                            variant="dark"
                                            className={cls(
                                                `focusable`,
                                              `${REGISTER}-button-footer`,
                                              `${REGISTER}-column-left-button`
                                            )}
                                            onClick={(): void => this.handlePromotions()}
                                            onFocus = {this.onFocus}
                                        >
                                            <span>
                                                {this.btnNumberMobile}
                                            </span>
                                        </Button>
                                    )}
                                </Column>

                                {!second && (
                                    <Column
                                        lg={6}
                                        className={cls(
                                            `${REGISTER}-column-top`,
                                            `${REGISTER}-column-left`
                                        )}
                                    >
                                        <Button
                                            type="button"
                                            variant="dark"
                                            className={cls(
                                                `focusable`,
                                                !isTelmex ?`${REGISTER}-button-footer`:
                                                `${REGISTER}-button-login-telmex`,
                                                `${REGISTER}-column-right`)}
                                            onClick={this.gotoLogin}
                                            onFocus = {this.onFocus}
                                        >
                                            <span>
                                                {this.getComponent('button_login')}
                                            </span>
                                        </Button>
                                    </Column>
                                )}
                            </Row>
                        </Column>
                    </Form>
                </Row>
            </Grid>
        );
    }
}
function mapStateToProps(state: any) {
    return {
        modal: state.modal ? { ...state.modal } : {
            modalType: null
        },
    }
}
export default connect(mapStateToProps, {showModal, receiveIsLoggedIn, setMetricsEvent, fetchPushSession, fetchLinealChannels})(Register);




// WEBPACK FOOTER //
// ./src/authentication/Register/index.tsx